export default "__VITE_ASSET__CSOk0JnK__"